import { inject, provideEnvironmentInitializer } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AmplitudeService } from "@dcc/shared/amplitude";
import { ConsentCategories, CookieConsentService } from "@dcc/shared/cookie-consent";
import { distinctUntilChanged, filter, map, tap } from "rxjs";

export function provideAmplitudeConsentInitializer() {
    return provideEnvironmentInitializer(() => {
        const amplitude = inject(AmplitudeService);
        const cookieConsentService = inject(CookieConsentService);

        cookieConsentService.consentChange$
            .pipe(
                takeUntilDestroyed(),
                distinctUntilChanged((a, b) => a[ConsentCategories.statistic] === b[ConsentCategories.statistic]),
                map((consentCategories) => consentCategories[ConsentCategories.statistic]),
                filter((shouldTrack) => !shouldTrack),
                tap(() => amplitude.stopTracking())
            )
            .subscribe();
    });
}
